(function ($) {
    class rTabs {
        constructor(elem, settings) {
            this.$elem = $(elem);
            this.nav = settings['nav'];
            this.query = settings['query'];
            this.tabs = {};
            this.collapse = settings['collapse'];

            // this.create();
            this.createOrDestroy();

            if (this.query) {
                $(window).on('resize', () => this.createOrDestroy());
            }
        }

        create() {
            const $navWrapper = this.nav ? this.$elem.find(this.nav) : this.$elem;

            for (let trigger of Array.from($navWrapper.find('.js-tabs-trigger'))) {
                const target = $(trigger).attr('data-target'),
                    $content = this.$elem.find('.js-tabs-content[data-tab="' + target + '"]');

                this.tabs[target] = new rTab($(trigger), $content);

                $(trigger).on('click', () => $(trigger).trigger('ruiTabClicked'));
                $(trigger).on('ruiTabClicked', () => this.toggleTab(target));
            }

            this.$elem.addClass('tabs-are-active');
        }

        destroy() {
            for (let key in this.tabs) {
                this.tabs[key].hideTab();
                this.tabs[key].$trigger.off('ruiTabClicked');
            }

            this.$elem.removeClass('tabs-are-active');
        }

        createOrDestroy() {
            if (this.getTabsState()) {
                if (!this.$elem.hasClass('tabs-are-active')) {
                    this.create();
                }
            } else if (this.$elem.hasClass('tabs-are-active')) {
                this.destroy();
            }
        }

        getTabsState(query = this.query) {
            let state = false;

            if (!query) {
                return true;
            }

            for (let value of query.split(';')) {
                if ($('.c-var .' + value + '-is-visible').is(':visible')) {
                    state = true;
                }
            }

            return state;
        }

        toggleTab(target) {
            for (let key in this.tabs) {
                if (this.tabs.hasOwnProperty(key)) {
                    if (key == target && !(this.tabs[key].active && this.collapse)) {
                        this.tabs[key].showTab();
                    }
                    else if (this.tabs[key].active) {
                        this.tabs[key].hideTab();
                    }
                }
            }
        }
    }

    class rTab {
        constructor($trigger, $content) {
            this.$trigger = $trigger;
            this.$content = $content;
            this.active = $trigger[0].hasAttribute('data-active');

            this.init();
        }

        init() {
            if (this.active) {
                this.showTab();
            }
        }

        showTab() {
            this.active = true;
            this.$trigger.addClass('is-active');
            this.$content.addClass('is-active');

            this.$content.trigger('ruiTabShowed');
        }

        hideTab() {
            this.active = false;
            this.$trigger.removeClass('is-active');
            this.$content.removeClass('is-active');
        }
    }

    $.fn.rTabs = function (options) {
        return this.each(function () {
            let settings = $.extend({
                query: false,
                active: false,
                collapse: false,
                nav: false,
            }, options, $(this).data());

            rui.rTabs.push(new rTabs(this, settings));
        });
    }
})(jQuery);

$(function () {
    $('.js-tabs').rTabs();
});
